<template>
  <v-container>
    <SporiciProgramDialog v-if="sporici_program_id!=null" :id="sporici_program_id.toString()" @close="sporici_program_id=null;" :moje="true"></SporiciProgramDialog>
    <JednorazovyNakupDialog v-if="jednorazovy_nakup_id!=null" :id="jednorazovy_nakup_id.toString()" @close="jednorazovy_nakup_id=null" :moje="true"></JednorazovyNakupDialog>
    <v-layout class="mt-3" row wrap v-if="!loading">
      <HesloDialog v-if="vyzadovana_zmena_hesla" v-model="vyzadovana_zmena_hesla" :stare_heslo="zmena_hesla_stare_heslo"></HesloDialog>
      <GdprDialog v-if="gdpr" v-model="gdpr"></GdprDialog>
      <v-flex xs12 v-if="sporici_programy.length > 0">
        <h2 class="mb-3">Aktuální postupné nákupy</h2>
      </v-flex>
      <v-layout v-if="sporici_programy.length == 0" row wrap>
        <v-flex xs12>
          <v-card class="px-3 pt-3 pb-0 elevation-0 mb-4">
            <v-card-title primary-title class="pa-0 mb-4 justify-center">
              <h3>Výhody postupného nákupu:</h3>
            </v-card-title>
            <v-layout row wrap class="px-2__row">
              <v-flex sm6 class="px-2">
                <ul class="dashboard-list">
                  <li class="mb-3"><v-icon color="orange" class="mr-2">check_box</v-icon> Průměrování ceny v&nbsp;čase</li>
                  <li class="mb-3"><v-icon color="orange" class="mr-2">check_box</v-icon> Fyzický kov v&nbsp;průběhu spoření</li>
                </ul>
              </v-flex>
              <v-flex sm6 class="px-2">
                <ul class="dashboard-list">
                  <li class="mb-3"><v-icon color="orange" class="mr-2">check_box</v-icon> Jeden účet pro celou rodinu</li>
                  <li class="mb-3"><v-icon color="orange" class="mr-2">check_box</v-icon> Flexibilita ve splácení</li>
                </ul>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout v-else row wrap class="shop-layout">
        <v-flex xs12 sm6 class="px-3" v-for="n in sporici_programy">
          <div class="actual-purchase">
            <v-layout row wrap align-center>
              <v-flex xs12 md6>
                <div class="slitek">
                  <!-- <zaplaceno-procent :title="n.nasporena_castka_procento>=100?'Vše zaplaceno':'Rozespořeno'" :procento="n.nasporena_castka_procento"></zaplaceno-procent> -->
                  <zaplaceno-procent :procento="n.nasporena_castka_procento >= 100 ? 100 : n.rozesporeno_procent" :obrazek="n.cilovy_produkt.obrazky.length > 0 ? 'https://uw-comfort-com-images.s3.eu-west-1.amazonaws.com/' + n.cilovy_produkt.obrazky[0].s3_nazev : null"></zaplaceno-procent>
                </div>
              </v-flex>
              <v-flex xs12 md6>
                <div class="actual-purchase__text">
                  <!-- <h3 class="mb-20 text-xs-left">{{n.nazev_sporeni}}</h3> -->
                  <h3 class="mb-20 text-xs-left" v-if="n.material.identifikator=='gold'">Zlatý cíl</h3>
                  <h3 class="mb-20 text-xs-left" v-else>Stříbrný cíl</h3>
                  <div class="mb-2 text-xs-left">
                    <p class="ma-0 bold text-gray fs-12"><strong>Naspořená částka</strong></p>
                    <p class="h3 text-primary bold">{{n.nasporena_castka | formatMoney}} {{n.mena.zkratka}}</p>
                  </div>
                  <div class="mb-2 text-xs-left" v-if="n.prumerna_cena != null && n.prumerna_cena > 0">
                    <p class="ma-0 bold text-gray fs-12"><strong>Průměrná výše Vašeho nákupu</strong></p>
                    <p class="h3 bold">{{n.prumerna_cena | formatMoney}} {{n.mena.zkratka}}</p>
                  </div>
                  <div class="mb-2 text-xs-left">
                    <p class="ma-0 bold text-gray fs-12"><strong>Aktuální cena slitku</strong></p>
                    <p class="h3 bold">{{n.aktualni_cena.prodejni_cena | formatMoney}} {{n.mena.zkratka}}</p>
                  </div>
                  <div class="purchase-price text-md-left">
                    <div class="text-xs-left">
                      <p class="ma-0 bold text-gray fs-12"><strong>Cílová částka</strong></p>
                      <p class="ma-0 h3 bold">{{n.cilova_castka | formatMoney}} {{n.mena.zkratka}}</p>
                    </div>
                    <v-btn color="orange" dark class="elevation-0 ma-0 bold" :class="{'mt-3': $vuetify.breakpoint.smAndUp}" @click="sporici_program_id=n.id"><v-icon class="ma-0">remove_red_eyes</v-icon> Detail</v-btn>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
        <v-flex xs12>
          <div class="text-xs-center">
            <button-link color="orange" dark depressed class="mx-0 mb-30 bold" :to="{ path: '/postupne-nakupy' }">Zobrazit všechny</button-link>
          </div>
        </v-flex>
      </v-layout>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <h2 class="mb-30">Elektronická peněženka</h2>
      </v-flex>
      <v-layout row wrap class="shop-layout">
        <v-flex xs12 sm4 class="px-3 pointer" v-for="p in penezenky" :key="'penezenka-'+p.id.toString()">
          <eshop-link :to="{ path: '/penezenka/'+p.mena.identifikator.toLowerCase() }" target="_blank">
            <div class="wallet-state wallet-dashboard credit-state__active link-black">
              <h3 class="h1 text-white">{{p.aktualni_zustatek | formatMoney}} {{p.mena.zkratka}}</h3>
            </div>
          </eshop-link>
        </v-flex>
      </v-layout>
      <v-flex xs12 class="text-xs-center">
        <button-link color="orange" dark depressed class="mx-0 mb-30 bold" :to="{ path: '/penezenka' }">Zobrazit více</button-link>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <h2 class="mb-30">Probíhající jednorázové nákupy:</h2>
        <v-data-table
          :headers="headersNeuzavrene"
          :items="jednorazove_nakupy"
          class="elevation-0 mb-30"
          hide-actions
        >
          <template v-slot:items="props">
            <td>{{ props.item.datum | formatSimpleDate }}</td>
            <td>{{ props.item.variabilni_symbol }}</td>
            <td class="text-xs-right">{{ props.item.castka_celkem | formatMoney }} <span v-if="props.item.mena!=null">{{props.item.mena.zkratka}}</span></td>
            <td class="text-xs-right"><span v-if="props.item.castka_celkem_fixace>0">{{ props.item.castka_celkem_fixace | formatMoney }} <span v-if="props.item.mena!=null">{{props.item.mena.zkratka}}</span></span><span v-else>--</span></td>
            <td><span v-if="props.item.stav_objednavky!=null">{{ props.item.stav_objednavky.nazev }}</span></td>
            <td class="text-xs-center">
              <a :href="api_url + 'faktury/' + props.item.fa_id + '/pdf'" v-if="props.item.fa_pdf" target="_blank">
                <v-btn color="orange" dark class="elevation-0 ma-0 bold"><v-icon class="mr-3">save_alt</v-icon> Faktura</v-btn>
              </a>
              <span v-else>--</span>
            </td>
            <td class="text-xs-right">
              <v-btn color="orange" dark class="elevation-0 ma-0 bold" @click="jednorazovy_nakup_id=props.item.id"><v-icon class="ma-0">remove_red_eyes</v-icon> Detail</v-btn>
            </td>
          </template>
        </v-data-table>
        <div class="text-xs-center" v-if="jednorazove_nakupy.length > 0">
          <button-link color="orange" dark depressed class="mx-0 mb-30 bold" :to="{ path: '/jednorazove-nakupy' }">Zobrazit všechny</button-link>
        </div>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <h2 class="mb-30">Zboží k předání:</h2>
        <v-data-table
          :headers="headers"
          :items="zbozi"
          class="elevation-0 mb-30"
          hide-actions
        >
          <template v-slot:items="props">
            <td>{{ props.item.datum | formatSimpleDate }}</td>
            <td><eshop-link :to="{ path: '/produkty/' + props.item.produkt.id }" target="_blank" class="link-black">{{ props.item.produkt.nazev }}</eshop-link></td>
            <td class="text-xs-right">{{ props.item.mnozstvi }}</td>
            <td>
              <span v-if="props.item.typ=='jednorazovy_nakup'">Jednorázový nákup č. {{props.item.polozka.variabilni_symbol}}</span>
              <span v-else-if="props.item.typ=='sporeni'">Postupný nákup {{props.item.polozka.nazev_sporeni}}</span>
            </td>
            <!-- <td>
              <span v-if="props.item.predano">Předáno</span>
              <span v-else-if="props.item.informovan">K předání</span>
            </td> -->
            <td>
              <span v-if="props.item.zpusob_predani != null">{{props.item.zpusob_predani.nazev}}</span>
            </td>
          </template>
        </v-data-table>
        <div class="text-xs-center" v-if="zbozi.length > 0">
          <button-link color="orange" dark depressed class="mx-0 mb-30 bold" :to="{ path: '/moje-zbozi' }">Zobrazit více</button-link>
        </div>
      </v-flex>
    </v-layout>
    <!-- <v-layout row wrap>
      <v-flex xs12>
        <h2 class="mb-30">Aktuality</h2>
      </v-flex>
      <v-layout row wrap class="shop-layout">
        <v-flex xs12 sm6 md4 class="pa-3" v-for="n in 3">
          <div class="news">
            <img src="@/assets/images/news.jpg" alt="Článek">
            <div class="news__text">
              <h3>Proč jsou komodity stále více diskutované téma.</h3>
              <p class="ma-0 bold text-gray">Jana Nová - 5 minut čtení</p>
            </div>
          </div>
        </v-flex>
      </v-layout>
      <v-flex xs12>
        <p class="text-xs-center ma-0">
          <a href="" class="button button-news" target="_blank">Více článků na commodity klubu</a>
        </p>
      </v-flex>
    </v-layout> -->
    <v-layout row wrap>
      <v-flex xs12>
        <h2 class="mb-30">Aktuální přehled vývoje zlata a&nbsp;stříbra</h2>
        <v-layout row wrap class="px-2__row">
          <v-flex xs12 sm6 class="px-2">
            <v-card class="white no__radius mt-4" v-if="zlato_chart!=null">
              <v-card-text class="px-0 pb-0">
                <apexchart width="100%" height="300" type="line" :options="zlato_chart.options" :series="zlato_chart.series"></apexchart>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6 class="px-2">
            <v-card class="white no__radius mt-4" v-if="stribro_chart!=null">
              <v-card-text class="px-0 pb-0">
                <apexchart width="100%" height="300" type="line" :options="stribro_chart.options" :series="stribro_chart.series"></apexchart>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <!-- <v-layout row wrap>
      <v-flex xs12>
        <div class="dashboard-cta">
          <img src="@/assets/images/gold.png" alt="Gold">
          <h4 class="text-white">Děláme z&nbsp;komodit investice a&nbsp;z&nbsp;investic komodity se ziskem.</h4>
          <img src="@/assets/images/logo-cc.svg" alt="Logo">
          <h3 class="text-white">Commodity klub</h3>
          <p class="ma-0"><a href="" target="_blank" class="link-white">www.commodityklub.cz</a></p>
        </div>
      </v-flex>
    </v-layout> -->
  </v-container>
</template>
<script>
  import Base from '../Base'
  import SporiciProgramDialog from '@/components/SporiciProgramDialog'
  import JednorazovyNakupDialog from '@/components/JednorazovyNakupDialog'
  import GdprDialog from '@/components/GdprDialog'
  import HesloDialog from '@/components/HesloDialog'
  export default {
    extends: Base,
    data () {
      return {
        loading: true,
        loadingTable: true,
        penezenky: [],
        headers: [
          { text: 'Datum', value: 'datum', sortable: false },
          { text: 'Produkt', value: 'produkt', sortable: false },
          { text: 'Množství', value: 'mnozstvi', sortable: false, align: 'right' },
          { text: 'Způsob pořízení', value: 'zpusob_porizeni', sortable: false },
          // { text: 'Stav', value: 'stav', sortable: false },
          { text: 'Způsob předání', value: null, sortable: false }
        ],
        headersNeuzavrene: [
          { text: 'Datum', value: 'datum', sortable: false },
          { text: 'Číslo obj. (VS)', value: 'variabilni_symbol', sortable: false },
          { text: 'Částka obj.', value: 'castka_celkem', sortable: false, align: 'right' },
          { text: 'Částka fixace', value: 'castka_celkem_fixace', sortable: false, align: 'right' },
          { text: 'Stav', value: 'stav.nazev', sortable: false },
          { text: 'Faktura', value: null, sortable: false, align: "center", width: '120px' },
          { text: 'Detail nákupu', value: null, sortable: false, align: "center", width: '120px' }
        ],
        mena: null,
        timeout: null,
        counter: 0,
        pagination: {
          descending: true,
          page: 1,
          rowsPerPage: 25,
          sortBy: "datum",
          totalItems: 0,
          pages: 0
        },
        sporici_programy: [],
        jednorazove_nakupy: [],
        sporici_program_id: null,
        jednorazovy_nakup_id: null,
        zbozi: [],
        zlato_chart: null,
        stribro_chart: null,
        gdpr: true,
        vyzadovana_zmena_hesla: false,
        zmena_hesla_stare_heslo: false,
      }
    },
    watch: {
      mena () {
        this.loadTable();
      },
      pagination: {
    		handler: function(newValue) {
          if (!this.loadingTable)
    			   this.loadTable();
    		},
    		deep: true
    	},
    },
    computed: {
      api_url () {
        return window.api.$api_url;
      }
    },
    mounted () {
      this.load();
    },
    methods: {
      load (f) {
        this.loading = true;
        window.API.get("nastenka").then(function(body) {
          this.sporici_programy = body.sporici_programy;
          this.jednorazove_nakupy = body.jednorazove_nakupy;
          this.gdpr = !body.gdpr;
          this.vyzadovana_zmena_hesla = body.zmena_hesla;
          this.zmena_hesla_stare_heslo = body.zmena_hesla_stare_heslo;
          this.zbozi = body.zbozi;
          this.zlato_chart = {
            options: {
              title: {
                text: "Vývoj ceny zlata",
                align: "center",
                style: {
                  fontSize:  '22px'
                },
              },
              chart: {
                id: 'vyvoj-ceny-zlata'
              },
              xaxis: {
                type: "datetime",
                labels: {
                  formatter: function (value) {
                    return moment(value*1000).format("D.M.Y");
                  }
                }
              },
              yaxis: {
                //min: _body.prodejni_ceny[$i].min,
                //max: _body.prodejni_ceny[$i].max,
                labels: {
                  formatter: function (value) {
                    return value.toFixed(2) + " Kč";
                  }
                },
              },
              tooltip: {
                x: {
                  formatter: function (value) {
                    return moment(value*1000).format("D.M.Y");
                  }
                }
              }
            },
            series: [{
              name: "Vývoj ceny zlata (1 oz)",
              data: body.vyvoj_cen_zlato.map((e) => { 
                return [
                  e.datum,
                  e.cena
                ];
              })
            }]
          };
          this.stribro_chart = {
            options: {
              title: {
                text: "Vývoj ceny stříbra",
                align: "center",
                style: {
                  fontSize:  '22px'
                },
              },
              chart: {
                id: 'vyvoj-ceny-stribra'
              },
              xaxis: {
                type: "datetime",
                labels: {
                  formatter: function (value) {
                    return moment(value*1000).format("D.M.Y");
                  }
                }
              },
              yaxis: {
                //min: _body.prodejni_ceny[$i].min,
                //max: _body.prodejni_ceny[$i].max,
                labels: {
                  formatter: function (value) {
                    return value.toFixed(2) + " Kč";
                  }
                },
              },
              tooltip: {
                x: {
                  formatter: function (value) {
                    return moment(value*1000).format("D.M.Y");
                  }
                }
              }
            },
            series: [{
              name: "Vývoj ceny stříbra (1 kg)",
              data: body.vyvoj_cen_stribro.map((e) => { 
                return [
                  e.datum,
                  e.cena
                ];
              })
            }]
          };
          window.API.get("penezenka").then(function(body) {
            this.penezenky.replace(body);
            this.loading = false;
            if (this.penezenky.length > 0)
              this.mena = this.penezenky[0].mena;
          }.bind(this)).catch(function(err) {
            console.log(err);
          }.bind(this));
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      },
      loadTable: function() {
        this.counter++;
        this.loadingTable = true;
        this.items = [];
        window.API.post("penezenka/"+this.mena.identifikator+"/platby/search", {
          pagination: this.pagination,
          s: this.search,
          echo: this.counter
        }).then(function(body) {
          if (this.counter != body.echo)
            return;
          this.items = body.data;
          this.pagination.sortBy = body.sort.sortBy;
          this.kategorie_items = [ { id: null, nazev: "Vše" } ].concat(body.kategorie);
          this.pagination.descending = body.sort.descending;
          this.pagination.page = body.sort.page;
          this.pagination.rowsPerPage = body.sort.rowsPerPage;
          this.pagination.totalItems = body.sort.totalItems;
          this.pagination.pages = body.sort.pages;
          this.loading = false;
          this.loadingTable = false;
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      },
    },
    components: {
      SporiciProgramDialog, JednorazovyNakupDialog, GdprDialog, HesloDialog
    }
  }
</script>
